import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import getPerPage from "../utils/getPerPage"
import useQueryParams from "./useQueryParams"

export interface PageConfig {
  PageNumber?: number
  PageSize?: number
  SearchText?: string
  OrderByColumnName?: string
  OrderBy?: number
}

export default function usePagination(name: string, defaultPerPage?: number) {
  const { lg } = useBreakpoint()
  const query = useQueryParams()
  defaultPerPage = defaultPerPage ? defaultPerPage : lg ? 10 : 5

  const object = query.values[name + "orderBy"] || {
    id: "DESC",
  }
  const objectkey =
    Object.keys((query.values[name + "orderBy"] as object) || {})[0] || ""
  // tog'a 1377 (2026-09-05): backend enum OrderBy { ASC = 1, DESC = 2 } — avval DESC→1 yuborilib, jadval TESKARI saralanardi
  // (strelka ▼, qatorlar esa o'sish tartibida). Endi DESC→2, ASC→1.
  const orderby = object[objectkey] === "DESC" ? 2 : 1
  const altName = name.endsWith("s") ? name.slice(0, -1) : name + "s"
  const searchTerm = query.values[name + "term"]?.toString() || query.values[altName + "term"]?.toString() || ""
  const pageConfig: PageConfig = {
    PageNumber: Number(query.values[name + "pageNumber"]) || 1,
    PageSize: getPerPage(name, defaultPerPage),
    SearchText: searchTerm,
    OrderByColumnName: objectkey,
    OrderBy: orderby,
  }
  //   useMemo(() => {
  //     const object = query.values[name + "orderBy"] || {
  //       id: "DESC",
  //     }
  //     const objectkey =
  //       Object.keys(
  //         (query.values[name + "orderBy"] as object) || { id: "DESC" }
  //       )[0] || "id"
  //     // tog'a 1377 (2026-09-05): backend enum OrderBy { ASC = 1, DESC = 2 } — avval DESC→1 yuborilib, jadval TESKARI saralanardi
  // (strelka ▼, qatorlar esa o'sish tartibida). Endi DESC→2, ASC→1.
  //     const orderby = object[objectkey] === "DESC" ? 2 : 1
  //     return {
  //       PageNumber: Number(query.values[name + "pageNumber"]) || 1,
  //       PageSize: getPerPage(name, defaultPerPage),
  //       SearchText: query.values[name + "term"]?.toString() || "",
  //       OrderByColumnName: objectkey,
  //       OrderBy: orderby,
  //     }
  //     // return query.values
  //   }, [
  //     query.values[name + "orderBy"],
  //     getPerPage(name, defaultPerPage),
  //     Number(query.values[name + "pageNumber"]),
  //     query.values[name + "term"]?.toString(),
  //   ])

  //   if (pageConfig.after) {
  //     delete pageConfig.last
  //     delete pageConfig.before
  //   }

  //   if (pageConfig.before) {
  //     delete pageConfig.first
  //     delete pageConfig.after
  //   }

  //   if (!pageConfig.before && !pageConfig.after) {
  //     delete pageConfig.last
  //     delete pageConfig.after
  //     delete pageConfig.before
  //   }

  return { pageConfig }
}
